import { CountryEntity } from 'api/types/entity';
import { useTranslation } from 'libs/i18n';
import { AddressFields, Section } from 'modules/client/common/components';

interface Props {
  countriesLoading?: boolean;
  countries: CountryEntity[];
}

export const CompanyResidentialAddressSection = ({
  countriesLoading,
  countries,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Section
      datax="companyResidentialAddressSection"
      title={t('client.legal.companyRegistrationAddress.titleResidential')}
    >
      <AddressFields
        countries={countries}
        countriesLoading={countriesLoading}
        variant="companyResidentialAddress"
      />
    </Section>
  );
};
